import { render, staticRenderFns } from "./DefectAssessor.vue?vue&type=template&id=1086ac83"
import script from "./DefectAssessor.vue?vue&type=script&lang=js"
export * from "./DefectAssessor.vue?vue&type=script&lang=js"
import style0 from "./DefectAssessor.vue?vue&type=style&index=0&id=1086ac83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports